import { wkblVideoInit } from 'redux/reducers/init';
import {
  changeWkblVideoAsc,
  changeWkblVideoGameDateFrom,
  changeWkblVideoGameDateTo,
  changeWkblVideoGameType,
  changeWkblVideoPage,
  changeWkblVideoReturnCount,
  changeWkblVideoSeason,
  changeWkblVideoSort,
  clearWkblVideoList,
  requestWkblVideoList,
  requestWkblVideoListFailure,
  requestWkblVideoListSuccess,
  addDownloadingGroup,
  removeDownloadingGroup,
  updateDownloadingGroup,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const wkblVideo = createReducer(wkblVideoInit, {
  [requestWkblVideoList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestWkblVideoListSuccess.type]: (state, action) => {
    const { videoList, pagination, returnCount } = action.payload;
    pagination.returnCount = returnCount;
    state.isLoading = false;
    state.videoList = videoList;
    state.pagination = pagination;
  },
  [requestWkblVideoListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.videoList = [];
  },
  [changeWkblVideoSeason.type]: (state, action) => {
    const { season } = action.payload;
    state.searchCondition.season = season;
  },
  [changeWkblVideoGameType.type]: (state, action) => {
    const { gameType } = action.payload;
    const { gameTypes } = state.searchCondition;

    const param: number[] = [...gameTypes];
    const parseValue = parseInt(gameType);

    const index = param.indexOf(parseValue);
    if (index !== -1) {
      const first = param.slice(0, index);
      const second = param.slice(index + 1);
      state.searchCondition.gameTypes = [...first, ...second];
    } else {
      param.push(parseValue);
      state.searchCondition.gameTypes = param;
    }
  },
  [changeWkblVideoGameDateFrom.type]: (state, action) => {
    const { gameDateFrom } = action.payload;
    state.searchCondition.gameDateFrom = gameDateFrom;
  },
  [changeWkblVideoGameDateTo.type]: (state, action) => {
    const { gameDateTo } = action.payload;
    state.searchCondition.gameDateTo = gameDateTo;
  },
  [changeWkblVideoPage.type]: (state, action) => {
    const { pageNumber } = action.payload;
    state.searchCondition.page = pageNumber;
  },
  [changeWkblVideoSort.type]: (state, action) => {
    const { sort } = action.payload;
    state.searchCondition.sort = sort;
  },
  [changeWkblVideoAsc.type]: (state, action) => {
    const { asc } = action.payload;
    state.searchCondition.asc = asc;
  },
  [changeWkblVideoReturnCount.type]: (state, action) => {
    const { returnCount } = action.payload;
    state.searchCondition.retr = returnCount;
    state.searchCondition.page = 0; // ReturnCount 변경시 1페이지부터 다시 조회
  },
  [clearWkblVideoList.type]: (state, action) => {
    state.videoList = [];
  },

  // [addDownloadingGroup.type]: (state, action) => {
  //   const { id } = action.payload;
  //   state.downloadingGroup[id] = {
  //     isDownloading: true,
  //     percent: 0,
  //   };
  // },

  // [removeDownloadingGroup.type]: (state, action) => {
  //   const { id } = action.payload;
  //   delete state.downloadingGroup[id];
  // },

  // [updateDownloadingGroup.type]: (state, action) => {
  //   const { percent, id } = action.payload;
  //   state.downloadingGroup[id].percent = percent;
  // },
});

export default wkblVideo;
